import LabServiceModel from "../LabServiceModel";

export default class NoteModel extends LabServiceModel {

    modelName() {
        return "notes";
    }

    icon() {
        return "page"
    }

    defaults() {
        return {
            id: null,
            note: null,
            notes_attachable_type: null,
            notes_attachable_id: null,
        };
    }

    mutations() {
        return {
            id: (val) => this.nullStringMutator(val),
            note: (val) => this.nullStringMutator(val),
            notes_attachable_type: (val) => this.nullStringMutator(val),
            notes_attachable_id: (val) => this.nullStringMutator(val),
        };
    }

    validation() {
        return {};
    }

}